import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Title = styled.h1`
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
`;

export const Wrapper = styled.div`
  grid-template-columns: 250px 250px 250px;
  display: grid;
  margin-top: 2.5rem;
  column-gap: 1rem;
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 1fr;
  }
`;
